import styled from "styled-components";
import { Variables } from "../../Variables";

export const ContainerGlobal = styled.div`
  box-sizing: border-box;
  position: relative;
  padding-top: 70px;
  width: 100%;
  min-height: 100vh;
  align-self: center;
  background-image: url("/imageBackHealth.png");
  background-repeat: no-repeat;
  background-size: cover;
`;

export const ContainerTransparent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  margin: 60px auto;
  margin-bottom: 100px;
  padding: 20px 20px;
  width: 60%;
  background-color: rgba(255, 255, 255, 0.5);
  backdrop-filter: blur(10px);
  border-radius: 10px;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.7);
`;

export const Back = styled.div`
  align-self: flex-start;
  padding: 5px;
  border-radius: 5px;
  font-weight: 600;
  background: rgba(0, 0, 0, 0.1);
  cursor: pointer;

  &:hover {
    opacity: 0.7;
  }
`;

export const Title = styled.h2``;

export const ContainerDad = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  margin-top: 20px;
  width: 90%;
`;

export const ContainerField = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 47%;
`;

export const OptionSupervision = styled.div`
  text-decoration: underline;
  color: ${Variables.colorBlue};
  cursor: pointer;

  :hover {
    opacity: 0.8;
  }
`;

export const TextInfo = styled.p`
  font-size: 18px;
  font-weight: 600;
`;

export const TextNoPay = styled.div`
  text-decoration: underline;
  color: ${Variables.colorBlue};
  cursor: pointer;

  :hover {
    opacity: 0.8;
  }
`;

export const TextAffiliateStatus = styled.p`
  color: ${Variables.colorGreenSuccess};
  font-weight: 600;
`;
export const TextUnaffiliatedStatus = styled.p`
  color: ${Variables.colorRed};
  font-weight: 600;
`;
export const TextPendingStatus = styled.p`
  color: ${Variables.colorOrange};
  font-weight: 600;
`;
